export let userActions = [];

export function getUserActions() {
    return userActions;
}

export function setUserActions(data) {
    userActions = data;
}
